import { createContext } from 'react';

import { useActivationSteps } from './useActivationSteps.hook';
import { LinkWithQuery } from '../components/LinkWithQuery/LinkWithQuery';
import { LoadingScreen } from '../components/LoadingScreen/LoadingScreen';
import Arrow from '../components/svg/Arrow.svg?react';

export const ActivationContext = createContext<{
  isOnboarded: boolean | undefined;
  isLoading: boolean;
}>({
  isOnboarded: undefined,
  isLoading: false,
});

export const Activation = ({ children }: { children: React.ReactNode }) => {
  const { progress, isOnboarded, isLoading } = useActivationSteps();

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <ActivationContext.Provider value={{ isOnboarded, isLoading }}>
      {children}
      {!isOnboarded && <ActivationModal progress={progress} />}
    </ActivationContext.Provider>
  );
};

function ActivationModal({ progress }: { progress: number }) {
  return (
    <div className="hidden m800:sticky m800:bottom-[0.2rem] m800:left-[0.2rem] m800:z-[9] m800:flex m800:min-h-[5rem] m800:w-[25rem] m800:flex-col m800:justify-between m800:self-start m800:border m800:border-activation-green m800:bg-white m800:p-[1rem_0.8rem] m800:shadow-activation">
      <div className="m800:flex m800:items-center m800:justify-between m800:[&>p]:m-0 m800:[&>p]:font-bold m800:[&>p]:text-denim-25">
        <p>Start using iwocaPay today</p>
        <LinkWithQuery
          to="/pay/activation/"
          className="m800:flex m800:items-center m800:justify-center m800:font-bold m800:text-denim-45 m800:no-underline"
        >
          <span>Finish setup</span>
          <Arrow className="m800:ml-[0.3rem]" />
        </LinkWithQuery>
      </div>
      <div className="m800:h-[0.5rem] m800:w-full m800:rounded-[0.5rem] m800:bg-london-90">
        <div
          className="m800:h-full m800:origin-left m800:rounded-[8px_0_0_8px] m800:bg-activation-green m800:transition-transform m800:duration-500 m800:ease-in-out"
          style={{ transform: `scaleX(${progress / 100})` }}
        ></div>
      </div>
    </div>
  );
}
